import React from "react";

import Modal from "react-bootstrap/Modal";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import { Spinner } from "../../../LoadingContainer/Spinner";

export default function InvitationSentModal({
  show,
  handleClose,
  email,
  isSending,
}) {
  return (
    <Modal
      centered
      animation={false}
      fullscreen="md-down"
      show={show}
      onHide={isSending ? () => {} : handleClose}
      backdrop="static"
      keyboard={!isSending}
      className="modal--lg"
    >
      <Modal.Body>
        {isSending ? (
          <div className="modal-body-heading">
            <h1
              className="modal-body-heading-title"
              data-testid="invitation-resending-title"
            >
              Resending invitation…
            </h1>
            <p data-testid="invitation-resending-email-line">
              Sending to {email}
            </p>
            <div className="d-flex justify-content-center mt-4">
              <Spinner variant="dark" size="lg" />
            </div>
          </div>
        ) : (
          <>
            <div className="modal-body-heading">
              <h1
                className="modal-body-heading-title"
                data-testid="invitation-sent-title"
              >
                Invitation sent
              </h1>
              <p data-testid="invitation-sent-email-line">
                Your invite was sent to {email}
              </p>
              <p>
                Let your team member know they can find the invitation link in
                their email.
              </p>
            </div>
            <Stack className="btn-group-flex">
              <Button size="lg" onClick={handleClose}>
                Close
              </Button>
            </Stack>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
